import { StyledCalendar } from './Calendar.style';
import { DateRangePicker } from 'react-dates';
import { Flex } from 'components/base/layout-components';
import withDateInView from 'components/PeriodPicker/components/PeriodsSelection/Calendar/hoc/withDateInView';
import useCalendarConfig from './useCalendarConfig';

const CalendarWithDateInView = withDateInView(DateRangePicker);

const Calendar = ({ forecast, dateInView, handleMonthChange }) => {
  const { renderDayContents, isOutsideRange } = useCalendarConfig({ forecast });

  return (
    <StyledCalendar>
      {/* this Flex->div layout fixes the react date-picker from showing the Inputs */}
      <Flex>
        <div>
          <CalendarWithDateInView
            dateInView={dateInView}
            isOutsideRange={isOutsideRange}
            hideKeyboardShortcutsPanel
            focusedInput='startDate'
            onFocusChange={() => {}}
            transitionDuration={0}
            renderDayContents={renderDayContents}
            daySize={45}
            firstDayOfWeek={1}
            onPrevMonthClick={newMonth => handleMonthChange(newMonth)}
            onNextMonthClick={newMonth => handleMonthChange(newMonth)}
          />
        </div>
      </Flex>
    </StyledCalendar>
  );
};

export default Calendar;
